<template>
  <div id="previerlive">
<!--    <div style="width: 100%;height: 40px"> 直播预告</div>-->
    <div class="c-loading" v-if="loading">
      <div class="c-loading-c">
        <img src="../assets/loading.svg">
        <div>加载中...</div>
      </div>

    </div>

    <div class="" v-else>

      <div class="video_placeholder" :style="{height:video_height+'px'}">
        <img :src="data.live_img">
        <div class="video_placeholder_cont">
          <div>距离直播开始</div>
          <div v-html="html" class="video_placeholder_date"></div>
        </div>
      </div>
      <div class="content">
        <div class="content-title">{{data.livename}}</div>
        <div class="content-text font-nomal" v-html="TextAreaText2Html(data.notice)"></div>
        <div class="content-text font-nomal" >{{data.publish_time}}</div>
      </div>

      <a href="http://img2.yitoutiao.net/app/download.html" class="bottom_btn_">下载APP查看更多精彩评论</a>
    </div>


  </div>
</template>
<style scoped>
  .content-title{ font-size: 18px; color: #323232; padding: 15px 0; font-weight: bold;  padding-bottom: 10px; line-height: 24px; text-align: justify}
  .content-title span{ vertical-align: middle}
  .content-text{ font-size: 12px; color: #8e8e8e; line-height: 18px;text-align: justify}
  .bottom_btn_ {
    display: block;
    width: 15rem;
    margin: 0.6rem auto;
    border-radius: 1rem;
    text-align: center;
    color: #fff;
    background: #ee1a1a;
    bottom: 2.45rem;
    padding: 0.3rem 0.4rem;
    font-size: 1rem;
  }
  .video_placeholder img{ width: 100%; height: 100%}
  .video_placeholder{ overflow: hidden; position: relative}
  .video_placeholder_cont{ position: absolute; left: 0; top: 0; width: 100%; height: 100%; color: #fff; display: flex; flex-direction: column; justify-content: center; align-items: center; font-size: 16px; background-color: rgba(0,0,0,0.3)}
  .video_placeholder_date{ display: flex; align-items: center; margin-top: 10px}

  @font-face {
    font-family: "Oswald-Medium";
    src: url("../assets/css/Oswald-Regular.ttf");
  }

</style>
<style>
  .time-big-text{ display: flex; justify-content: center; align-items: center; width: 46px;height: 50px; border:0.5px solid rgba(255,255,255,0.5); border-radius: 4px; margin: 0 8px;font-family: Oswald-Medium;
    font-size: 30px; font-weight: bold}
</style>
<script>
// @ is an alias to /src
import layVideo from '@/components/Video.vue'
import request from "../utils/request";
import utils from "../utils";

export default {
  name: 'defaultVideoContent',
  data(){
    return {
      id:this.$route.params.id,
      html:'',
      timer:false,
      data:{
        cover:"",
        play_url:"",
        movie_name:""
      },
      video_height:200

    }
  },
  components: {
    layVideo
  },
  created() {
    this.getdata();
    try{
      document.querySelector(".toplink").style.display = 'block';
    }catch (e) {

    }
  },
  mounted() {
    var _this = this;
    function resize(){
      var w = window.innerWidth;
      if(w>750){
        w=750
      }
      _this.video_height=w/(16/9);
    }
    window.onresize = function () {
      resize()
    }
    resize()
    document.querySelector(".toplink").style.display = 'block';
  },
  methods:{
    TextAreaText2Html: function TextAreaText2Html(text) {
      return utils.TextAreaText2Html(text);
    },
    getDate() {
      function tow(n) {
        if(n<0){
          return 0
        }
        return n >= 0 && n < 10 ? '0' + n : '' + n;
      }
      if(!this.data.start_time){
        return
      }
      var oDate = new Date();//获取日期对象
      var oldTime = oDate.getTime();//现在距离1970年的毫秒数
      var newDate = new Date(this.data.start_time*1000);
      var newTime = newDate.getTime();//2019年距离1970年的毫秒数
      var second = Math.floor((newTime - oldTime) / 1000);//未来时间距离现在的秒数
      var day = Math.floor(second / 86400);//整数部分代表的是天；一天有24*60*60=86400秒 ；
      second = second % 86400;//余数代表剩下的秒数；
      var hour = Math.floor(second / 3600);//整数部分代表小时；
      second %= 3600; //余数代表 剩下的秒数；
      var minute = Math.floor(second / 60);
      second %= 60;
      // var str = tow(day) + '<span class="time">天</span>'
      //         + tow(hour) + '<span class="time">小时</span>'
      //         + tow(minute) + '<span class="time">分钟</span>'
      //         + tow(second) + '<span class="time">秒</span>';

      if(tow(day)===0 && tow(hour)===0 && tow(minute)===0 && tow(second)===0){
        clearInterval(this.timer)
        location.href = "http://img2.yitoutiao.net//web/video/share.html?id="+this.id

      }


      var str = ''
      if(tow(day) !=="00"){
        str = `
          <div class="time-big-text"><span>${tow(day)}</span></div><span class="small-text">天</span>

          <div class="time-big-text"><span>${tow(hour)}</span></div><span class="small-text">时</span>
          <div class="time-big-text"><span>${tow(minute)}</span></div><span class="small-text">分</span>
          <div class="time-big-text"><span>${tow(second)}</span></div><span class="small-text">秒</span>
        `
      }else{
        str = `
          <div class="time-big-text"><span>${tow(hour)}</span></div><span class="small-text">时</span>
          <div class="time-big-text"><span>${tow(minute)}</span></div><span class="small-text">分</span>
          <div class="time-big-text"><span>${tow(second)}</span></div><span class="small-text">秒</span>
        `
      }

      this.html = str
    },
    getdata(){
      request.getLiveVideoInfo(this.id,(res)=>{
        console.log(res)
        this.loading = false;
        this.timer = setInterval(this.getDate,1000)
        if(res && res.code===200){
          this.data = res.data;
          request.getWeixinShanre(location.href,(s_res)=>{
            let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
            let shareconfig = {appId,timestamp,nonceStr,signature};
            if(utils.is_weixin()){
              if(res.data){
                let sharedata = {
                  title:res.data.livename,
                  desc:res.data.notice?res.data.notice:"看度时政直播预告",
                  link:location.href,
                  imgUrl:thumb
                };
                utils.setWeiXinShare(sharedata,shareconfig,false)
              }

            }
          });


        }
      })
    }
  }
}
</script>
